/* eslint-disable import/prefer-default-export, prefer-destructuring */
import { updateCSS } from 'rc-util/lib/Dom/dynamicCSS';
import { TinyColor } from '@ctrl/tinycolor';
export default function changeTheme(globalPrefixCls, theme, baseColor) {
    // 格式化颜色
    const formatColor = (color, updater) => {
        let clone = color.clone();
        clone = (updater === null || updater === void 0 ? void 0 : updater(clone)) || clone;
        return clone.toRgbString();
    };
    // 透明度
    const fade = (color, percentage) => {
        const clone = color.clone();
        return clone.setAlpha(clone.getAlpha() * (percentage / 100));
    };
    // 透明度增加
    // const fadeIn = (color: TinyColor, percentage: number) => {
    //   const clone = color.clone();
    //   // 2. 获取原alpha值（若颜色不透明，默认为1）
    //   const originalAlpha = clone.getAlpha();
    //   // 3. 计算新alpha值（增加amount%，并限制在0~1）
    //   const newAlpha = Math.min(originalAlpha + percentage / 100, 1);
    //   // 4. 设置新alpha值
    //   const resultColor = clone.setAlpha(newAlpha);
    //   return resultColor;
    // };
    const getVariables = () => ({
        // 主色
        [`primary-color`]: baseColor.base_primary,
        // 主色 fade 24%,用于复制时背景色
        [`primary-color-f-24`]: formatColor(new TinyColor(baseColor.base_primary), c => fade(c, 24)),
        // 按钮hover背景色，用于button组件hover背景色及其他背景色
        [`primary-color-hover-bg`]: formatColor(new TinyColor(baseColor.base_primary), c => fade(c, theme === 'light' ? 8 : 16)),
        // 主色 fade 8%, 备用
        [`primary-color-f-8`]: formatColor(new TinyColor(baseColor.base_primary), c => fade(c, 8)),
        // 主色 fade 16%, 备用
        [`primary-color-f-16`]: formatColor(new TinyColor(baseColor.base_primary), c => fade(c, 16)),
        // 浮层里hover背景色
        [`primary-1`]: baseColor.dropdown_hover_bg,
        // 双层hover背景色,叠加hover背景色后的色号,用于table选中行hover底色
        [`primary-1-double`]: baseColor.primary_1_double,
        // hover描边
        [`primary-color-hover`]: baseColor.primary_color_hover,
        // 背景色或描边（active）
        [`primary-color-active`]: baseColor.primary_color_active,
        // 主阴影色 fade(@primary_color_hover, 8%)
        [`primary-color-outline`]: formatColor(new TinyColor(baseColor.primary_color_hover), c => fade(c, 8)),
        // 非浮层里hover背景色
        [`item-hover-bg`]: baseColor.item_hover_bg,
        // 普通色,用于分割线 滚动
        [`normal-color`]: baseColor.normal_color,
        // 普通色, fade 50%， 用于深色模式下全局时间组件浮层头部背景色
        [`normal-color-f-50`]: formatColor(new TinyColor(baseColor.normal_color), c => fade(c, 50)),
        // 文字颜色（页面、按钮）
        [`text-color`]: baseColor.text_color,
        // 图标色
        [`text-color-secondary`]: baseColor.text_color_secondary,
        // 图标色 darken 10%,用于Noticfication关闭按钮hover背景色
        [`text-color-secondary-d-10`]: formatColor(new TinyColor(baseColor.text_color_secondary), c => c.darken(10)),
        // 文字颜色（标题）
        [`heading-color`]: baseColor.heading_color,
        // 背景色（页面、表头）
        [`background-color-base`]: baseColor.background_color_base,
        // 背景色（页面、表头）shade 5%,用于骨架组件
        [`background-color-base-s-5`]: formatColor(new TinyColor(baseColor.background_color_base), c => c.shade(5)),
        // 禁用文字颜色（placeholder文字颜色、图标颜色）
        [`disabled-color`]: baseColor.disabled_color,
        // 禁用文字颜色（placeholder文字颜色、图标颜色）fade 10%,用于Switch组件聚焦后的边框阴影
        [`disabled-color-f-10`]: formatColor(new TinyColor(baseColor.disabled_color), c => fade(c, 10)),
        // 信息色
        [`info-color`]: baseColor.base_primary,
        // 成功色
        [`success-color`]: baseColor.success_color,
        // 成功色
        [`success-color-bg`]: formatColor(new TinyColor(baseColor.success_color), c => fade(c, 12)),
        // 警告色
        [`warning-color`]: baseColor.warning_color,
        // 警告色背景
        [`warning-color-bg`]: formatColor(new TinyColor(baseColor.warning_color), c => fade(c, 12)),
        // 错误色
        [`error-color`]: baseColor.error_color,
        // 错误色阴影
        [`error-color-outline`]: formatColor(new TinyColor(baseColor.error_color), c => fade(c, 8)),
        // 错误色背景
        [`error-color-bg`]: formatColor(new TinyColor(baseColor.error_color), c => fade(c, 12)),
        // 背景颜色（回显标签）
        [`selection-item-bg`]: baseColor.selection_item_bg,
        // body背景
        [`body-bg`]: baseColor.body_bg,
        // 卡片背景
        [`card-bg`]: baseColor.card_bg,
        // dropdown浮层背景色
        [`dropdown-bg`]: baseColor.dropdown_bg,
        // dropdown描边色，用于浮层、下拉框、页面容器卡片描边
        [`dropdown-border-color`]: baseColor.dropdown_boder_color,
        // 阴影色
        [`shadow-color`]: baseColor.shadow_color,
        // 阴影色 fade 75%,用于table固定列阴影、tabs头部导航阴影
        [`shadow-color-f-75`]: formatColor(new TinyColor(baseColor.shadow_color), c => fade(c, 75)),
        // 文字提示背景色
        [`tooltip-bg`]: baseColor.tooltip_bg,
        // 表头背景色
        [`table-header-color-bg`]: baseColor.table_header_color_bg,
        // modal/drawer内容区背景色
        [`modal-drawer-content-bg`]: baseColor.modal_drawer_content_bg,
        // 圆角
        [`border-radius-12`]: baseColor.border_radius_12,
    });
    // Convert to css variables
    const variables = getVariables();
    const cssList = Object.keys(variables).map(key => `--${globalPrefixCls}-${key}: ${variables[key]};`);
    updateCSS(`
    :root {
      ${cssList.join('\n')}
      color-scheme: ${theme === 'dark' ? 'dark' : 'light'};
    }
    `, `${globalPrefixCls}-dynamic-theme`);
}
